import { render, staticRenderFns } from "./BillingBanner.vue?vue&type=template&id=5922fc62&scoped=true&"
import script from "./BillingBanner.vue?vue&type=script&lang=js&"
export * from "./BillingBanner.vue?vue&type=script&lang=js&"
import style0 from "./BillingBanner.vue?vue&type=style&index=0&id=5922fc62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5922fc62",
  null
  
)

export default component.exports